<template>
  <div
    v-if="createdByUser || lastModifiedByUser"
    class="audit-info"
  >
    <div v-if="createdByUser">
      Created by {{ createdByUser.firstName }} {{ createdByUser.lastName }} {{ $methods.formatDate(createdDate) }}
    </div>
    <div v-if="lastModifiedByUser">
      Last Modified by {{ lastModifiedByUser.firstName }} {{ lastModifiedByUser.lastName }} {{ $methods.formatDate(lastModifiedDate) }}
    </div>
  </div>
</template>

<script lang="ts">
import { User } from '@/@types/responses/user/User'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AuditInformation',
  props: {
    createdByUser: {
      type: User,
      required: true
    },
    createdDate: {
      type: String,
      required: true
    },
    lastModifiedByUser: {
      type: User,
      required: true
    },
    lastModifiedDate: {
      type: String,
      required: true
    }
  }
})
</script>

<style scoped lang="scss">
.audit-info {
  margin-top: 15px;
  font-size: 12px;
  line-height: 18px;
  font-weight: normal;
  color: $Color-font-medium;
}
</style>